'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import ErrorPage from '@local/common/ui/components/error/ErrorPage';
import errorCode from 'http-status';
import ThemeRegistry from '@local/ui/ThemeRegistry';

export default function GlobalError({ error }) {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <html>
            <body>
                <ThemeRegistry>
                    <ErrorPage statusCode={errorCode.INTERNAL_SERVER_ERROR} />
                </ThemeRegistry>
            </body>
        </html>
    );
}
